import { Market, MarketsGroupedByMarketType } from '../@types';
import { MARKET_DISPLAY_TYPE } from '../types/enums';

export type Rule = {
  match: (m: Market) => boolean;
  key: (m: Market) => string;
  label: (m: Market) => string;
};

export const createRule = <T extends Rule>(rule: T): T => rule;

export const isMatchResultTotalsMarket = (name?: string) => {
  return /^match result and total goals over\/under x$/i.test(name?.trim() || '');
};

export const shouldGroupMatchResultTotalsMarket = (market: Market) =>
  market.displayType === MARKET_DISPLAY_TYPE.GROUPED && isMatchResultTotalsMarket(market.marketType?.name);

export const ftbRules: Rule[] = [
  createRule({
    match: (market) => shouldGroupMatchResultTotalsMarket(market),
    key: (market) => market.marketTypeId,
    label: (market) => `${market.marketType?.shortName || market.marketType?.name}`,
  }),
];

export const applyMarketGrouping = (
  markets: Market[],
  rules: Rule[] = ftbRules
): (Market | MarketsGroupedByMarketType)[] => {
  const result: (Market | MarketsGroupedByMarketType)[] = [];

  markets.forEach((market) => {
    const rule = rules.find((r) => r.match(market));

    if (!rule) {
      result.push(market);
      return;
    }

    const groupId = rule.key(market);
    const groupLabel = rule.label(market);
    const existing = result.find((item) => item.id === groupId);

    if (existing && 'markets' in existing) {
      existing.markets.push(market);
      return;
    }

    result.push({
      id: groupId,
      marketType: groupId,
      name: groupLabel,
      shortName: market.shortName,
      description: market.description,
      markets: [market],
      isCollapsedMode: market.isCollapsedMode,
      position: market.position,
      favourite: market.favourite,
    });
  });

  return result;
};
